import script from "./Vueform.vue?vue&type=script&lang=js"
export * from "./Vueform.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__